/**
 * Created by pajicv on 9/27/18.
 */
import React from 'react';
import { TextField, withStyles } from '@material-ui/core';

const styles = theme => ({
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: 40,
        width: 400
    },
    innerContainer: {
        width: '100%',
        textAlign: 'center',
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    input: {
        textAlign: 'center'
    },
    dateContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    dateField: {
        margin: 20
    }
});

class ProjectTitle extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: props.title
        };
    }

    handleChange = (e) => this.setState({title: e.target.value});

    render() {
        const { classes, onEndEditing, onDateChange, startDate, endDate } = this.props;
        const { title } = this.state;
        return (
            <div>
                <div className={classes.innerContainer}>
                    <TextField
                        id="standard-bare"
                        className={classes.textField}
                        defaultValue=""
                        margin="normal"
                        value={title}
                        onChange={this.handleChange}
                        onBlur={() => onEndEditing(title)}
                        inputProps={{
                            className: classes.input
                        }}
                        placeholder="Projektname"
                    />
                    <div classnName={classes.dateContainer}>
                    <TextField
                        id="startDate"
                        label="Start"
                        type="date"
                        value={startDate}
                        className={classes.dateField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={ (e) => onDateChange('startDate', e.target.value) }
                    />
                    <TextField
                        id="endDate"
                        label="Ende"
                        type="date"
                        value={endDate}
                        className={classes.dateField}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={ (e) => onDateChange('endDate', e.target.value) }
                    />
                </div>
        </div>
    </div>
);

    }
}
export default withStyles(styles)(ProjectTitle);



// WEBPACK FOOTER //
// ./src/components/ProjectSetup/ProjectTitle.js